import React from 'react';

import { AppLayout } from '@contexts/index';

export function useAppLayout() {
  const context = React.useContext(AppLayout.Context);

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (context === undefined) {
    throw new Error(`useAppLayout must be used within a AppLayoutProvider`);
  }

  const { state, dispatch } = context;

  const setTitle = React.useCallback(
    (title: string) => {
      dispatch({
        type: AppLayout.Actions.SetTitle,
        title,
      });
    },
    [dispatch]
  );

  return { state, setTitle };
}
